<p>sb-atom-type-groups-wrapper works!</p>
